/**
 * Header on scroll and hamburger menu
 */

const headerMenu = () => {
  const header = document.querySelector('.js-header') as HTMLElement;
  const burger = document.querySelector('.js-burger') as HTMLElement;
  const menu = document.querySelector('.js-menu') as HTMLElement;
  const navLinks = document.querySelectorAll('.js-burger-link') as NodeListOf<HTMLElement>;
  const btns = document.querySelectorAll('.js-btn') as NodeListOf<HTMLElement>;
  const burgerText = document.querySelector('.header__burger-text') as HTMLElement;

  if (header && burger && burgerText) {
    const handleScroll = () => {
      if (window.location.pathname === '/') {
        if (window.scrollY >= (window.innerHeight - 100)) {
          header.classList.add('scrolled');
          header.classList.add('lower');
        } else if (!header.classList.contains('active')) {
          header.classList.remove('scrolled');
          header.classList.remove('lower');
        }
      } else {
        if (window.scrollY > 0) {
          header.classList.add('scrolled');
          header.classList.add('lower');
        } else if (!header.classList.contains('active')) {
          header.classList.remove('scrolled');
          header.classList.remove('lower');
        }
      }
    };

    const handleBurgerClick = () => {
      header.classList.toggle('active');
      burger.classList.toggle('active');
      if (header.classList.contains('active')) {
        header.classList.add('scrolled');
        burgerText.textContent = 'CLOSE';
      } else {
        if (window.scrollY === 0) {
          header.classList.remove('scrolled');
        }
        burgerText.textContent = 'MENU';
      }
      document.body.classList.toggle('overflow');
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (
        !menu.contains(event.target as Node) &&
        !burger.contains(event.target as Node)
      ) {
        header.classList.remove('active');
        burger.classList.remove('active');
        burgerText.textContent = 'MENU';
        document.body?.classList.remove('overflow');
      }
    };

    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        header.classList.remove('active');
        burger.classList.remove('active');
        burgerText.textContent = 'MENU';
        document.body?.classList.remove('overflow');
      });
    });

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        header.classList.remove('active');
        burger.classList.remove('active');
        burgerText.textContent = 'MENU';
        document.body?.classList.remove('overflow');
      });
    });

    window.addEventListener('scroll', handleScroll);
    burger.addEventListener('click', handleBurgerClick);
    document.addEventListener('click', handleClickOutside);
  }
};

export default headerMenu;
